import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  textHead: {
    fontWeight: 600,
    fontSize: 14
  },
  tableCell: {
    borderBottom: '2px solid #CCCCCC',
    backgroundColor: '#ffffff'
  }
};

const enhance = compose();

const tableHead = enhance(
  ({
    order,
    orderBy,
    onRequestSort,
    classes,
    fromTopPageGroup,
    isFukuoka,
    isTable2
  }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell
            sortDirection={orderBy === 'shopId' ? order : false}
            className={classes.tableCell}
          >
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'shopId'}
              direction={order}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              {isFukuoka ? '教室ID' : '店舗ID'}
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'shopName' ? order : false}
            className={classes.tableCell}
          >
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              {isFukuoka ? '教室名' : '店舗名'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'gochiBuyAmount' ? order : false}
              className={classes.tableCell}
            >
              <TableSortLabel
                className={classes.textHead}
                active={orderBy === 'gochiBuyAmount'}
                direction={order}
                onClick={() => {
                  onRequestSort('gochiBuyAmount');
                }}
              >
                ごち購入額
              </TableSortLabel>
            </TableCell>
          )}

          <TableCell
            sortDirection={orderBy === 'gochiUsedAmount' ? order : false}
            className={classes.tableCell}
          >
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'gochiUsedAmount'}
              direction={order}
              onClick={() => {
                onRequestSort('gochiUsedAmount');
              }}
            >
              {isFukuoka ? '利用額' : 'ごち利用額'}
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={
              orderBy === 'depositAmountCurrentMonth' ? order : false
            }
            className={classes.tableCell}
          >
            <TableSortLabel
              className={classes.textHead}
              active={orderBy === 'depositAmountCurrentMonth'}
              direction={order}
              onClick={() => {
                onRequestSort('depositAmountCurrentMonth');
              }}
            >
              {isFukuoka ? '精算金額' : '入金金額'}
              {!fromTopPageGroup && !isFukuoka && (
                <>
                  <br />
                  ※1
                </>
              )}
            </TableSortLabel>
          </TableCell>
          {!isTable2 && (
            <TableCell
              sortDirection={
                orderBy === 'depositAmountNextMonth' ? order : false
              }
              className={classes.tableCell}
            >
              <TableSortLabel
                className={classes.textHead}
                active={orderBy === 'depositAmountNextMonth'}
                direction={order}
                onClick={() => {
                  onRequestSort('depositAmountNextMonth');
                }}
              >
                {isFukuoka ? '精算予定金額' : '入金予定金額'}
                {!fromTopPageGroup && !isFukuoka && (
                  <>
                    <br />
                    ※2
                  </>
                )}
              </TableSortLabel>
            </TableCell>
          )}
          {!fromTopPageGroup && (
            <TableCell className={[classes.textHead, classes.tableCell]}>
              {isFukuoka ? '精算明細' : '入金明細'}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(tableHead);
